import { Theme } from '../types';
import { TokenProp } from './types';
import { useTokenProp } from './utils';

export type GradientColor = string[];

export interface LinearGradientTokens {
  HIBISCUS: GradientColor;
  YELLOW: GradientColor;
  TEAL: GradientColor;
  NAVY: GradientColor;
  VIOLET: GradientColor;
  BLUE: GradientColor;
  MINT: GradientColor;
}

export type LinearGradientToken = keyof LinearGradientTokens;
export type LinearGradientTokenProp = TokenProp<LinearGradientToken>;

interface StyledProps {
  theme: Theme;
  color: LinearGradientTokenProp;
}

export const useLinearGradientColorProp = useTokenProp<
  LinearGradientToken,
  StyledProps
>(
  'background',
  ({ color }) => color,
  ({ theme }, token) => {
    const colors = theme.linearGradient[token as LinearGradientToken];
    return `linear-gradient(180deg, ${colors[0]} 0%, ${colors[1]} 100%)`;
  }
);
